import { ArrowButton } from 'components';
import { useAuth } from 'context/AuthContext';
import { GoogleAnaliticsEvent } from 'enum';
import { Job } from 'graphql/generated';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logAnalyticsEvent } from 'ui-services/analytics.ui-service';
import { EasyApplyDialog } from 'views/job-detail/components/easy-apply-dialog';

type EasyApplyProps = {
    job: Job;
};

export const EasyApply: React.FC<EasyApplyProps> = ({ job }) => {
    const { applied } = job;
    const { t } = useTranslation();
    const { isLoggedIn, openModal } = useAuth();
    const [open, setOpen] = useState(false);
    const [isApplied, setIsApplied] = useState(applied);

    const openDialog = (): void => {
        logAnalyticsEvent(GoogleAnaliticsEvent.EASY_APPLY_CLICKED);
        setOpen(true);
    };

    return (
        <>
            {!isApplied ? (
                <ArrowButton
                    style={{
                        padding: '18px 20px',
                        fontSize: '20px',
                    }}
                    text={t('jobDetails:easyApply')}
                    hasIcon={false}
                    disableRipple={false}
                    onClick={() => (isLoggedIn ? openDialog() : openModal())}
                />
            ) : (
                <ArrowButton
                    style={{
                        backgroundColor: 'rgb(67, 160, 71, 0.08)',
                        color: 'rgb(67, 160, 71)',
                        padding: '18px 20px',
                        fontSize: '20px',
                        boxShadow: 'none',
                    }}
                    text={t('jobTags:applied')}
                    hasIcon
                    disableRipple
                    disabled
                />
            )}
            {open ? <EasyApplyDialog job={job} {...{ setIsApplied, isApplied, open, setOpen }} /> : null}
        </>
    );
};
